import Square from "../Square";
import './Podium.css'

function Podium({ handleSlotClick, girlPicked }) {


  return(
    <div className="main_container">
      <div className="podium_container">
        <div className="col1">
          <Square id={0} handleSlotClick={handleSlotClick} isSelected={false} girlPicked={girlPicked}/>
          <Square id={1} handleSlotClick={handleSlotClick} isHidden={true} isSelected={true} girlPicked={girlPicked} />
          <Square id={2} handleSlotClick={handleSlotClick} isSelected={true} girlPicked={girlPicked} />
        </div>
        <div className="col2">
          <Square id={3} handleSlotClick={handleSlotClick} isHidden={true} isSelected={true} girlPicked={girlPicked} />
          <Square id={4} handleSlotClick={handleSlotClick} isSelected={true} girlPicked={girlPicked} />
          <Square id={5} handleSlotClick={handleSlotClick} isSelected={true} girlPicked={girlPicked} />
        </div>
        <div className="col3">
          <Square id={6} handleSlotClick={handleSlotClick} isSelected={true} girlPicked={girlPicked} />
          <Square id={7} handleSlotClick={handleSlotClick} isSelected={true} girlPicked={girlPicked} />
          <Square id={8} handleSlotClick={handleSlotClick} isSelected={true} girlPicked={girlPicked} />
        </div>
      </div>
    </div>
  )
}

export default Podium;